// globals
var CFL = {
  UA: {
    raw: function raw() {
      return navigator.userAgent;
    },
    is: function is(_is) {
      var ua = CFL.UA.raw();
      if (_is === 'issp') {
        return CFL.UA.isSp();
      }
    },
    isSp: function isSp() {
      var ua = CFL.UA.raw();
      return ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0;
    },
    isTablet: function() {
      var ua = CFL.UA.raw();
      if(ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
      } else if (ua.indexOf('iPad') > -1
         || (ua.indexOf('Macintosh') > -1 && CFL.UA.Device.isTouch() )
         || ua.indexOf('Android') > 0) {
        return true;
      }

      return false;
    },
    isEdge: function() {
      return this.raw().indexOf('Edge') != -1;
    },
    isIE: function() {
      var ua = CFL.UA.raw();
      return this.raw().indexOf('Trident') != -1 ;
    }
  },
  Device: {
    isTouch: function() {
      return 'ontouchend' in document;
    }
  }
};

var isMobile = function () {
  return (window.matchMedia('(max-width: '+ APP.bp.mobile +'px)').matches)
}

var isPortrait = function() {
  let defaultOrientation = null;
  if('orientation' in window) {
    var o1 = (window.innerWidth < window.innerHeight);
    var o2 = (window.orientation % 180 == 0);
    defaultOrientation = (o1 && o2) || !(o1 || o2);
  }
  if('orientation' in window) {
    // defaultOrientationがtrueの場合、window.orientationが0か180の時は縦
    // defaultOrientationがfalseの場合、window.orientationが-90か90の時は横
    var o = (window.orientation % 180 == 0);
    if((o && defaultOrientation) || !(o || defaultOrientation)) {
      return true;
    } else {
      return false;
    }
  }
}
class ConceptSwiper {
  constructor(el, opt) {
    this.el = el;
    if($(this.el).length){
      this.event();
    }
  }
  event(){
    this.swiper = new Swiper(this.el, {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
    });
  }
}

class File {
  constructor(el, opt) {
    this.el = el;
    if($(this.el).length){
      this.event();
    }
  }
  event(){
    $(function(){
      $("input[type='file']").on('change',function(){
         var file = $(this).prop('files')[0];
         if(!($(".filename").length)){
           $("#input-group").append('<span class="filename"></span>');
         }
         $("#file").addClass('changed');
         $(".filename").html(file.name);
       });
     });

  }
}

class Header {
  constructor(el, opt) {
    this.el = el;
    if($(this.el).length){
      this.event();
    }
  }
  event(){
    $(function() {
      $(window).on("scroll", function () {
        const sliderHeight = $(".s-mv").height();
        if (sliderHeight - 30 < $(this).scrollTop()) {
          $("body").removeClass("top");
        } else {
          $("body").addClass("top");
        }
      });
  });
  }
}

class InviewEvent {
  constructor(el, opt){
    this.el = el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    this.event();
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    $(item).find(this.eachItem).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.2 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}

class Menu {
  constructor(el, opt) {
    this.el = el;
    if($(this.el).length){
      this.event();
    }
  }
  event(){
    $(function() {
      $('.hamburger').click(function() {
          $(this).toggleClass('active');
   
          if ($(this).hasClass('active')) {
              $('.globalMenu').addClass('active');
              $('.l-header__logo').addClass('active');
          } else {
              $('.globalMenu').removeClass('active');
              $('.l-header__logo').removeClass('active');
          }
      });
  });
  }
}

class Parameter {
  constructor(el, opt) {
    this.el = el;
    if($(this.el).length){
      this.event();
    }
  }
  event(){
    const urlParams = new URLSearchParams(window.location.search);
    const selectedValue = urlParams.get('id');
  
    if (selectedValue) {
      const selectBox = document.querySelector('#parameter select');
      selectBox.style.color = 'rgb(51, 51, 51)';
      
      selectBox.value = selectedValue;
    }
  }
}

class More {
  constructor(el, opt) {
    this.el = el;
    if($(this.el).length){
      this.event();
    }
  }
  event(){
    if($(".js-item-list li").length <= 8) {
      $(".js-more").css({"display": "none"});
    } else {
      $(this.el).on({
        click: function() {
          $(".js-item-list li:nth-of-type(n + 9)").css({'display': 'block'})
          $(this).css({'display': 'none'})
          return false;
        }
      })
    }
  }
}
class Scroll {
  constructor(el, opt) {
    this.el = el;
    if($(this.el).length){
      this.event();
    }
  }
  event(){
    $(function () {
      if (window.matchMedia('(max-width: 768px)').matches) {
        
      } else {

        var timeoutId ;
        window.addEventListener( "scroll", function () {
        // setTimeout()がセットされていたら無視
        if ( timeoutId ) return ;
        timeoutId = setTimeout( function () {
          timeoutId = 0 ;
          $(window).scroll(function() {
            if(window.scrollY + $(".js-header")[0].clientHeight > $(".js-footer")[0].offsetTop) {
                $(".js-header").addClass("is-active");
            } else {
                $(".js-header").removeClass("is-active");
            }
        })
        }, 500 ) ;
        } ) ;
      }
    })

  }
}

class Select {
  constructor(el, opt) {
    this.el = el;
    if($(this.el).length){
      this.event();
    }
  }
  event(){
    $(function(){
      $('select').on('change', function(){
          if($(this).val() == "placeholder"){
              $(this).css('color','rgba(51,51,51,0.4)')
          } else {
              $(this).css('color','#333')
          }
      });
  });
  }
}

class SelectImg {
    constructor(el, opt) {
      this.el = el;
      // if($(this.el).length){
      // }
      this.event();
    }
    event(){
      $(function() {

        if($(".error").length || $(".mw_wp_form_confirm").length) {
          for(let i = 1; i < 4; i++) {
            if($.cookie(`input-group0${i}`)) {
              $(`#input-group0${i} .send-text`).text($.cookie(`input-group0${i}`));
            }
          }
        }

        const files = document.querySelectorAll('.send-img')
        const imgTll = document.querySelectorAll('.send-text')
        const btn = document.querySelector(".submitBtn")

        // var date = new Date();
        // date.setTime( date.getTime() + ( 5 * 1000 ));

        files.forEach((file, index) => {

          $(file).on('change', function () { //ファイルが選択されたら
            let file = $(this).prop('files')[0]; //ファイルの情報を代入(file.name=ファイル名/file.size=ファイルサイズ/file.type=ファイルタイプ)
            $(this).parent().next().text(file.name);

            $.cookie($(this).parent().parent().attr("id"), file.name);
          });
        });

        if($(".submitBtn[value='send']").length) {
          $(".submitBtn[value='send']").click(function() {
            for(var i = 1; i < 4; i++) {
              if($.cookie(`input-group0${i}`)) {
                $.removeCookie(`input-group0${i}`);
              }
            }
          })
        }
      });
    }
  }
class Switching {
  constructor(el, opt) {
    this.el = el;
    if($(this.el).length){
      this.event();
    }
  }
  event(){
    $(function () {
      $(".js-sub-img img").on("click", function () {
        const img = $(this).attr("src");
        $(".js-sub-img li").removeClass("current");
        $(this).parent().addClass("current");
        $(".js-main-img img").fadeOut(500, function () {
          $(".js-main-img img")
            .attr("src", img)
            .on("load", function () {
              $(this).fadeIn();
            });
        });
      });
    });    
  }
}

// globals
class Top {
  constructor(el, opt) {
    this.el = el;
    if($(this.el).length){
      this.event();
    }
  }
  event(){
    this.swiper = new Swiper('.pSwiper', {
      slidesPerView: 1.3,
      centeredSlides : true,
      navigation: {
        nextEl: ".s-service-ele02__btn-right",
        prevEl: ".s-service-ele02__btn-left"
      },
      breakpoints: {
        960: {
          centeredSlides : false,
          slidesPerView: 3,
        }
      },
    });

    this.swiper = new Swiper('.wSwiper', {
      slidesPerView: 1.3,
      spaceBetween: 0,
      centeredSlides : true,
      navigation: {
        nextEl: ".s-service-ele04__btn-right",
        prevEl: ".s-service-ele04__btn-left"
      },
      breakpoints: {
        960: {
          centeredSlides : false,
          slidesPerView: 3,
          spaceBetween: 0,
        }
      },
    });
  }
}

class WorkshopForm {
  constructor(el, opt) {
    this.el = el;
    if($(this.el).length){
      this.event();
    }
  }
  event(){
    $(".js-ws-name").text(this.getParam('title'));
    $("[name='ワークショップ名']").attr('value', this.getParam('title'));
    $(".js-date").text(this.getParam('date'));
    $("[name='開催日']").attr('value', this.getParam('date'));
    $(".js-price").text(this.getParam('price'));
    $("[name='料金']").attr('value', this.getParam('price'));
    $(".js-remarks").text(this.getParam('remarks'));
    $("[name='備考']").attr('value', this.getParam('remarks'));
  }
  getParam(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }
}


(() => {

})();

//DOMContentLoaded
$(() => {
});

//images resources loaded
$(window).on('load', () => {
  let conceptSwiper = new ConceptSwiper('.swiper-container');
  let switching = new Switching('.js-sub-img');
  let menu = new Menu('.hamburger');
  let select = new Select('select');
  let file = new File('#input-group');
  let scroll = new Scroll('.js-header');
  let top = new Top('.p-top');
  let more = new More('.js-more');
  let workshopForm = new WorkshopForm('.js-wsForm');
  let parameter = new Parameter('.js-parameter');
  let header = new Header('.p-top');
  let inviewEvent = new InviewEvent('.js-inview');
  let selectImg = new SelectImg('.js-select-img');
  $(window).trigger('loading');
});

//after loading animation
$(window).on('loading', () => {

});

// スマホ・タブレットの向き判定
// $(window).on('orientationchange', ()=>{
//   if(isPortrait()){
//     console.log('isPortrait');
//   } else {
//     console.log('isLandscape');
//   }
// });